import React from "react";

import { Checkmark } from "@culturehq/components";

import { Trans } from "app/utils";

const AcceptPolicies = ({
  acceptedPrivacyPolicies = undefined,
  agreed,
  policiesAgreed,
  organization,
  onAgreeChange,
  onPrivacyPolicyChange
}) => {
  const { name: organizationName, privacyPolicyEnabled, privacyPolicies } = organization || {};

  return (
    <>
      {(privacyPolicyEnabled || !!privacyPolicies?.length) && !acceptedPrivacyPolicies && (
        <>
          <div className="Login__Accept__terms">
            {privacyPolicyEnabled && (
              <Checkmark checked={agreed} onClick={onAgreeChange}>
                <div>
                  <Trans>I agree to</Trans> CultureHQ&#39;s{" "}
                  <a href="https://www.culturehq.com/privacy-policy">
                    <Trans>Privacy</Trans>
                  </a>{" "}
                  <Trans>and</Trans>{" "}
                  <a href="https://www.culturehq.com/acceptable-use-policy">
                    <Trans>Acceptable Use policies</Trans>
                  </a>.
                </div>
              </Checkmark>
            )}

            {privacyPolicies?.map((privacyPolicy, index) => (
              <div key={String(index)}>
                <br />
                <Checkmark
                  checked={policiesAgreed[index]}
                  onClick={value => onPrivacyPolicyChange(value, index)}
                >
                  {organizationName === "Boston Scientific" ? (
                    <span>
                      <Trans>
                        By checking this box, I agree for my name and photographs, video footage
                        or audio to be used by Boston Scientific for use in marketing, PR and
                        publications in connection with the event as described in this
                      </Trans>
                      {" "}
                      <a href={privacyPolicy.url} target="_blank" rel="noopener noreferrer">Privacy Notice</a>.
                    </span>
                  ) : (
                    <span>
                      <Trans>I agree to</Trans> {organizationName}&#39;s{" "}
                      <a href={privacyPolicy.url} target="_blank" rel="noopener noreferrer">
                        {privacyPolicy.text}
                      </a>.
                    </span>
                  )}
                </Checkmark>
              </div>
            ))}
          </div>

          {organizationName === "Verizon" && (
            <p className="Login__Accept__Disclaimer">
              <Trans>
                CultureHQ makes sharing and connecting both easy and fun. Please
                be mindful that your engagement on the platform is subject to
                Verizon&apos;s Code of Conduct and Social Media Guidelines (as
                applicable). Conduct in violation of Verizon&apos;s Code or other
                applicable policies may result in your access to CultureHQ being
                revoked as well as corrective action, up to and including
                termination of employment.
              </Trans>
            </p>
          )}
        </>
      )}
    </>
  );
};

export default AcceptPolicies;
